import { useTranslation } from "react-i18next";

/** "2 ч", "45 мин", "1 ч 30 мин" — an interval given in minutes. */
export function useIntervalLabel(): (minutes: number) => string {
  const { t } = useTranslation();
  return (minutes) => {
    const whole = Math.max(1, Math.round(minutes));
    const hours = Math.floor(whole / 60);
    const rest = whole % 60;
    if (hours === 0) return t("broadcasts.unit.minutes", { n: rest });
    if (rest === 0) return t("broadcasts.unit.hours", { n: hours });
    return `${t("broadcasts.unit.hours", { n: hours })} ${t("broadcasts.unit.minutes", { n: rest })}`;
  };
}
